import React from 'react';
import ListLoaderLayout from 'src/components/10-atoms/loaders/ListLoaderLayout';
const ReputationBadgeLoader = ({ ...listLoaderLayoutProps }) => {
    return React.createElement(ListLoaderLayout, { loaderItemHeight: 72, ...listLoaderLayoutProps });
};
export default ReputationBadgeLoader;
